<template>
  <div id="hrms15e-detail3Desc3">
    <template v-if="detail.rows.length > 0">
      <template v-if="parseInt(detail.rows[detailIndex].total) > 0">
        <div class="main-topic-box">
          <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click="triggerSetDetailTab3Desc3Selected(-1)"></i>
          <div class="main-topic">{{ labels['HRAP31EC10']['40'] }} {{ detailTab3Desc3Selected.kpino }}</div>
          <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click="triggerSetDetailTab3Desc3Selected(1)"></i>
        </div>
        <div class="detail-header" ><h4><u>{{ labels['HRAP31EC10']['140'] }}</u></h4></div>

        <template v-if="!isEmpty(detail.rows[detailIndex].tableDesc3)">
          <div class="detail detail-responsive">
            <div class="detail-block">
              <hrms-table :columns="detail3Desc3Table"
                          :data="{ total: detail.rows[detailIndex].tableDesc3.length, rows: detail.rows[detailIndex].tableDesc3 }"
                          :indexDisp="false"
                          :searchDisp="false" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }} {{ labels['HRAP31EC10']['140'] }}</label>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="evaluation-sum ">
          <div class="form-group ">
            <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }} {{ labels['HRAP31EC10']['140'] }}</label>
          </div>
        </div>
      </template>
    </template>
  </div>

</template>

<script>
import _ from 'lodash'

export default {
  name: 'hrms15e-detail3Desc3',
  data () {
    return {
      detailIndex: 0
    }
  },
  watch: {
    detailTab3Desc3IndexSelected () {
      this.detailIndex = this.detailTab3Desc3IndexSelected
    }
  },
  methods: {
    isEmpty (detailTab3Desc3Selected) {
      return _.isEmpty(detailTab3Desc3Selected)
    },
    triggerSetDetailTab3Desc3Selected (index) {
      this.detailIndex += index
      if (this.detailIndex < 0) {
        this.detailIndex = this.detail.rows.length - 1
      }
      if (this.detailIndex > this.detail.rows.length - 1) {
        this.detailIndex = 0
      }
      this.setDetailTab3Desc3IndexSelected(this.detailIndex)
      this.setDetailTab3Desc3Selected(this.detail.rows[this.detailIndex])
    }
  },
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'detail3Desc3Table',
    'detailTab3Desc3Selected',
    'setDetailTab3Desc3Selected',
    'detailTab3Desc3IndexSelected',
    'setDetailTab3Desc3IndexSelected',
    'labelsHrms15e'
  ]
}
</script>




// WEBPACK FOOTER //
// detail3Desc3.vue?68d497ee